import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import { ENABLE_MODAL_RETRIES } from '../../RequestManagerConstants';

class ContentRecommendationsV1Task extends AbstractRequestTask {

    constructor(groupId = {}, quantity = 10, filterlist = "31032,30978", is_only_provider = false) {
        super();
        this.groupId = groupId;
        this.quantity = quantity;
        this.filterlist = filterlist;
        this.is_only_provider = is_only_provider;
    }

    getHeaders() {
        return {};
    }

    getUrl() {
      const http = "https://";
      const url = Launcher.get("akamai_mfwk");
      return `${http}${url}/services/content/v1/recommendations`;
    }

    getParams() {
        const params = super.getParams();
        delete params.HKS;
        delete params.api_version;
        const newParams = {
          group_id: this.groupId,
          quantity: this.quantity,
          filterlist: this.filterlist,
          is_only_provider: this.is_only_provider,
        };

        return { ...params, ...newParams };
    }

    success(data, b) {
        this.resolve(data);
    }

    getShowErrorModal(){
        return ENABLE_MODAL_RETRIES;
    }
}

export default ContentRecommendationsV1Task;



// WEBPACK FOOTER //
// ./src/requests/tasks/content/ContentRecommendationsV1Task.js